var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdiLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Path_white_Mask",
    "data-name": "Path + white Mask",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.192,
    height: 95.192,
    viewBox: "0 0 95.192 95.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    cx: 47.596,
    cy: 47.596,
    r: 47.596,
    fill: "#ffd000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2424",
    "data-name": "Rect\\xE1ngulo 2424",
    width: 48.135,
    height: 29.661,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Mask-2",
    "data-name": "Mask",
    cx: 47.596,
    cy: 47.596,
    r: 47.596,
    transform: "translate(0 0)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18988",
    "data-name": "Grupo 18988",
    transform: "translate(22.529 34.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18930",
    "data-name": "Grupo 18930",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13699",
    "data-name": "Trazado 13699",
    d: "M0,32.769l.664-.789a2.91,2.91,0,0,0,1.983.815c.683,0,1.114-.322,1.114-.788v-.018c0-.448-.252-.689-1.418-.959C1.01,30.709.256,30.314.256,29.159v-.018A1.92,1.92,0,0,1,2.4,27.323a3.488,3.488,0,0,1,2.279.788l-.592.834A2.856,2.856,0,0,0,2.382,28.3c-.645,0-1.023.332-1.023.743v.019c0,.484.288.7,1.5.985,1.327.323,2.01.8,2.01,1.837V31.9c0,1.173-.923,1.872-2.243,1.872a3.875,3.875,0,0,1-2.62-1m6.8-5.356h4.657V28.4H7.911v1.631h3.15v.985H7.911V32.7h3.6v.985h-4.7Zm6.24,3.152v-.018A3.2,3.2,0,0,1,16.286,27.3a3.4,3.4,0,0,1,2.413.85l-.7.833a2.463,2.463,0,0,0-1.759-.671A2.122,2.122,0,0,0,14.2,30.53v.018a2.1,2.1,0,0,0,2.136,2.239,2.572,2.572,0,0,0,1.517-.474V31.138H16.25v-.957h2.674v2.633a4.008,4.008,0,0,1-2.619.976,3.113,3.113,0,0,1-3.257-3.225m7.893.457v-3.61h1.1v3.564c0,1.165.6,1.782,1.588,1.782s1.58-.582,1.58-1.737v-3.61h1.1v3.555a2.506,2.506,0,0,1-2.7,2.814,2.474,2.474,0,0,1-2.674-2.759m7.6-3.61h2.8a2.535,2.535,0,0,1,1.813.626,1.9,1.9,0,0,1,.52,1.352v.018a1.884,1.884,0,0,1-1.49,1.9l1.7,2.373h-1.31L31.027,31.5H29.645v2.185h-1.1Zm2.719,3.108c.789,0,1.292-.413,1.292-1.049v-.017c0-.672-.485-1.04-1.3-1.04H29.645v2.106Zm4.017.044v-.018a3.284,3.284,0,0,1,6.568-.018v.018a3.284,3.284,0,0,1-6.568.018m5.41,0v-.018a2.149,2.149,0,0,0-2.135-2.231,2.121,2.121,0,0,0-2.119,2.213v.018a2.143,2.143,0,0,0,2.136,2.221,2.112,2.112,0,0,0,2.117-2.2m2.581,2.2.664-.789a2.91,2.91,0,0,0,1.983.815c.683,0,1.114-.322,1.114-.788v-.018c0-.448-.251-.689-1.418-.959-1.337-.322-2.091-.716-2.091-1.872v-.018a1.92,1.92,0,0,1,2.145-1.818,3.486,3.486,0,0,1,2.279.788l-.592.834a2.86,2.86,0,0,0-1.705-.645c-.647,0-1.023.332-1.023.743v.019c0,.484.286.7,1.5.985,1.327.323,2.01.8,2.01,1.837V31.9c0,1.173-.924,1.872-2.243,1.872a3.875,3.875,0,0,1-2.62-1",
    transform: "translate(-0.001 -4.129)",
    fill: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13700",
    "data-name": "Trazado 13700",
    d: "M25.428,18.992H32.5c7.692,0,11.552-3.988,11.552-9.6V9.334C44.048,3.718,40.27,0,32.713,0H25.428Zm6.362-5.2V5.2h1.06c2.909,0,4.784,1.294,4.784,4.268v.059c0,2.972-1.875,4.267-4.784,4.267Z",
    transform: "translate(-3.845 0)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2420",
    "data-name": "Rect\\xE1ngulo 2420",
    width: 6.343,
    height: 18.992,
    transform: "translate(41.788)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2421",
    "data-name": "Rect\\xE1ngulo 2421",
    width: 6.343,
    height: 6.328,
    transform: "translate(6.357 6.333)",
    fill: "#e60018"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2422",
    "data-name": "Rect\\xE1ngulo 2422",
    width: 6.343,
    height: 18.992,
    transform: "translate(12.704)",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2423",
    "data-name": "Rect\\xE1ngulo 2423",
    width: 6.343,
    height: 18.992,
    transform: "translate(0.01)",
    fill: "#006b2d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_943",
    "data-name": "L\\xEDnea 943",
    transform: "translate(13.192 6.348)",
    fill: "none",
    stroke: "#787372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.008
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_944",
    "data-name": "L\\xEDnea 944",
    transform: "translate(13.192 12.63)",
    fill: "none",
    stroke: "#787372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.008
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_945",
    "data-name": "L\\xEDnea 945",
    transform: "translate(0.003 0.168)",
    fill: "none",
    stroke: "#787372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.008
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_946",
    "data-name": "L\\xEDnea 946",
    transform: "translate(48.131 0.168)",
    fill: "none",
    stroke: "#787372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.008
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_947",
    "data-name": "L\\xEDnea 947",
    transform: "translate(48.131 18.988)",
    fill: "none",
    stroke: "#787372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.008
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13701",
    "data-name": "Trazado 13701",
    d: "M56.61,27.405",
    transform: "translate(-8.561 -4.144)",
    fill: "#9c9c9a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_948",
    "data-name": "L\\xEDnea 948",
    transform: "translate(48.049 23.261)",
    fill: "none",
    stroke: "#787372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.008
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13702",
    "data-name": "Trazado 13702",
    d: "M56.61,34.806",
    transform: "translate(-8.561 -5.263)",
    fill: "#9c9b9b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdiLoader);
export default __webpack_public_path__ + "static/media/hdiLoader.3562605ecb639f2060b1c92fa67119db.svg";
export { ForwardRef as ReactComponent };